import { GatewayStatus } from 'constants/gatewayStatuses';
import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { getGatewayDuplicateFormValues } from 'pages/Gateways/GatewaysCreate/utils/getGatewayDuplicateFormValues';
import { useGetList, useGetOne } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Gateway, GatewayStatus as GatewayStatusType } from 'types/embedded/gateway';
import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

export const GATEWAY_DUPLICATE_SOURCE_PARAM = 'duplicateFrom';

export const useGatewayCreateDefaultValues = () => {
  const [searchParams] = useSearchParams();
  const duplicateSourceId = searchParams.get(GATEWAY_DUPLICATE_SOURCE_PARAM);

  const { data: gatewayStatuses, isLoading } = useGetList<GatewayStatusType>('gateway_statuses');

  const { data: duplicateSource, isLoading: isDuplicateSourceLoading } = useGetOne<Gateway>(
    Resources.Gateways,
    { id: convertReactAdminIdToHydraId(duplicateSourceId || '', Resources.Gateways) },
    { enabled: !!duplicateSourceId },
  );

  const defaultStatusId = gatewayStatuses?.find(
    (status) => status.value === GatewayStatus.Active,
  )?.id;

  const formDefaultValues = useMemo(
    () =>
      duplicateSource
        ? getGatewayDuplicateFormValues(duplicateSource, defaultStatusId)
        : { status: defaultStatusId },
    [duplicateSource, defaultStatusId],
  );

  return { formDefaultValues, isLoading: isLoading || isDuplicateSourceLoading };
};
